import { debounce } from "@mui/material";
import { uploadFile } from "../components/uploadFile";
import { useDialog } from "../../../../../../context";
import replaceDomain from "../../../../../../utils/replaceDomain";

const formatError = (err) => {
  if (err?.response?.data?.message) return err.response.data.message;
  if (err?.message) return err.message;
  return "No response received from server.";
};

const useOnDrop = (getValues, insert, setValue, remove) => {
  const { showError } = useDialog();
  return async (acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    const currentValues = getValues("floorPlans"); // 👈 fresh values
    let updatedFields = [...currentValues];

    const file = acceptedFiles[0];
    const previewUrl = URL.createObjectURL(file);
    const nextLabel = `Floor ${
      updatedFields.filter((f) => !f.isRoof).length + 1
    }`;
    // const roofIndex = updatedFields.findIndex((f) => f.isRoof);
    // const insertIndex = roofIndex !== -1 ? roofIndex + 1 : 0;
    const insertIndex = 0;

    const newItem = {
      file,
      previewUrl,
      label: nextLabel,
      isRoof: false,
      isLabelCustom: false,
      uploading: true,
      uploadProgress: 0,
      cancelToken: null,
      serverId: null,
    };

    insert(insertIndex, newItem);
    const index = insertIndex; // index to track this field
    const debouncedSetProgress = debounce(
      (progress) => setValue(`floorPlans.${index}.uploadProgress`, progress),
      200 // ms delay
    );

    const { promise, cancel } = uploadFile(file, debouncedSetProgress);

    setValue(`floorPlans.${index}.cancelToken`, cancel); // store cancel function

    try {
      const response = await promise;

      setValue(`floorPlans.${index}.uploading`, false);
      setValue(`floorPlans.${index}.uploadProgress`, 100);
      setValue(`floorPlans.${index}.previewUrl`, replaceDomain(response.data)); // assuming server returns ID
    } catch (error) {
      if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
        console.info("Upload cancelled");
      } else {
        showError(formatError(error));
        console.error("Upload failed", error);
      }

      remove(index);
    }
  };
};

export default useOnDrop;
